(() => {
  const desktop = window.matchMedia('(min-width: 990px)');
  const template = () => document.getElementById('CustomKidsAgeMenuV1');
  const position = (menu, details) => {
    if (!desktop.matches || !details.open) return;
    const rect = details.getBoundingClientRect();
    const panelWidth = menu.getBoundingClientRect().width;
    const left = Math.max(20, Math.min(rect.left, window.innerWidth - panelWidth - 20));
    menu.style.setProperty('--custom-kids-panel-left', `${left - rect.left}px`);
  };
  const enhance = (summary, menu, mobile) => {
    if (!summary || !menu || !template() || menu.dataset.customKidsAgeMenu === 'true') return;
    const existing = Array.from(menu.children);
    const group = document.createElement('li');
    group.className = 'custom-kids-menu-v1__group';
    const heading = document.createElement('span');
    heading.className = 'custom-kids-menu-v1__heading';
    heading.textContent = 'Shop by Dress Type';
    const links = document.createElement('ul');
    links.className = 'custom-kids-menu-v1__links list-menu';
    links.setAttribute('role', 'list');
    links.append(...existing);
    group.append(heading, links);
    const age = template().content.cloneNode(true);
    if (mobile) {
      age.querySelectorAll('a').forEach((a) => {
        a.className = 'menu-drawer__menu-item link link--text list-menu__item focus-inset';
      });
      const typeHeading = document.createElement('li');
      typeHeading.className = 'custom-kids-menu-v1__heading';
      typeHeading.setAttribute('role', 'presentation');
      typeHeading.textContent = heading.textContent;
      const ageHeading = document.createElement('li');
      ageHeading.className = 'custom-kids-menu-v1__heading custom-kids-menu-v1__heading--age';
      ageHeading.setAttribute('role', 'presentation');
      ageHeading.textContent = age.querySelector('.custom-kids-menu-v1__heading').textContent;
      menu.append(typeHeading, ...links.children, ageHeading, ...age.querySelector('.custom-kids-menu-v1__links').children);
    } else {
      menu.append(group, age);
    }
    menu.classList.add('custom-kids-menu-v1');
    menu.dataset.customKidsAgeMenu = 'true';
    if (!mobile) {
      const details = summary.closest('details');
      const update = () => position(menu, details);
      details.addEventListener('toggle', () => { if (details.open) update(); });
      window.addEventListener('resize', update, { passive: true });
      document.fonts.ready.then(update);
    }
  };
  const initialize = () => {
    const summary = document.getElementById('HeaderMenu-kids-formal-dresses');
    enhance(summary, summary?.closest('details')?.querySelector(':scope > .header__submenu'), false);
    const mobileSummary = document.getElementById('HeaderDrawer-kids-formal-dresses');
    enhance(mobileSummary, mobileSummary?.closest('details')?.querySelector(':scope > .menu-drawer__submenu .menu-drawer__inner-submenu > ul'), true);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
